import { Cog } from 'lucide-react'
import { ToolbarItem } from '../../../common/components/ToolbarItem'
import { useHasUserPermissions } from '@wellesley/auth'
import { Tooltip } from '../../../common/components/Tooltip'

const adminSettingsId = 'admin-settings'

export const AdminSettingsItem = () => {
  const hasAccess = useHasUserPermissions([
    { resource: 'AdminSettings', actions: ['Read', 'Manage'] },
  ])

  if (!hasAccess) return null

  return (
    <Tooltip tooltipText="Server settings">
      <ToolbarItem
        id={adminSettingsId}
        name="Server settings"
        link="/admin"
        Icon={Cog}
        variant="square"
      />
    </Tooltip>
  )
}
